import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IInvoiceAssignAmountRouteParams {
    invoiceId: Guid
}

const InvoiceAssignAmountRoute = new AppRoute<IInvoiceAssignAmountRouteParams>({
    route: "/invoices/:invoiceId/assign-amount",
    navbar: true,
    authRequired: true,
})

export default InvoiceAssignAmountRoute
